import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromParcelShops from './store/parcelshops';

@NgModule({
	imports: [StoreModule.forFeature(fromParcelShops.featureKey, fromParcelShops.reducer), EffectsModule.forFeature([fromParcelShops.ParcelShopEffects])],
})
export class ParcelShopsStoreModule {}
